<div id="sidepanel">
    <div id="GPsidenav">
        <ul>
            <li class="leftnav-group">
                <button id="selectGroup" title="Select Group" (click)="showSlideOut('selectGroup')">
                    <span class="sbntext">Group</span>
                </button>
            </li>
            <li class="leftnav-dashboard">
                <button id="dashboard" (click)="navigateToRoute('dashboard')" title="Dashboard"
                    [disabled]="!selectedGroup?.accountName">
                    <span class="sbntext">Dashboard</span>
                </button>
            </li>
            <li class="leftnav-addmember">
                <button id="addMember" title="Add Member" (click)="showSlideOut('addMember')"
                    [disabled]="!selectedGroup?.accountName">
                    <span class="sbntext">Add Member</span>
                </button>
            </li>
            <li class="leftnav-members">
                <button id="members" (click)="navigateToRoute('members')" title="Members"
                    [disabled]="!selectedGroup?.accountName">
                    <span class="sbntext">Members</span>
                </button>
            </li>
            <li class="leftnav-mygroup">
                <button id="myGroup" (click)="navigateToRoute('myGroup')" title="My Group"
                    [disabled]="!selectedGroup?.accountName">
                    <span class="sbntext">My Group</span>
                </button>
            </li>
            <li class="leftnav-history">
                <button id="history" (click)="navigateToRoute('history')" title="History"
                    [disabled]="!selectedGroup?.accountName">
                    <span class="sbntext">History</span>
                </button>
            </li>
            <!-- <li id="blankli">&nbsp;</li> -->
        </ul>
        <div class="lnblank">&nbsp;</div>
    </div>
</div>
<div id="mySidepanel" class="mysidepanel">
    <div [hidden]="slideOutType != 'selectGroup'">
        <div class="sidebar-header">
            <!-- slideOutBlur() -->
            <h2 class="black"><span class="snHeadingArrow" (click)="slideOutBlur()"><i
                        class="fa fa-chevron-left"></i></span>Group</h2>
            <p *ngIf="groupList?.length > 0">Select a group ({{groupList?.length}})</p>
        </div>

        <ul class="list-unstyled components">
            <li *ngFor="let group of groupList" class="gpGroupList">
                <a (click)="selectGroup(group.acepId)">
                    {{group.accountName}} 
                    <span [ngClass]="'account-category'">
                        ({{group.accountCategory}})
                    </span>
                </a>
            </li>
            <li [hidden]="groupList?.length > 0">
                <p>You are currently not assigned to a group. Please contact
                    <a href="{{globalDataOpsService.BasePath}}/membership/account/#contactus">Member Care</a> for
                    assistance.
                </p>
            </li>
        </ul>
    </div>
    <div class="FlowupLabels" [hidden]="slideOutType != 'addMember'">
        <div class="sidebar-header">
            <h2 class="black"><span class="snHeadingArrow" (click)="slideOutBlur()"><i
                        class="fa fa-chevron-left"></i></span>Add Member</h2>
        </div>
        <div
            [hidden]="showContactForm || selectedContactDetails?.showSuccessMsg || showInvalidResidencyMsg">
            <div class="fl_wrap" [ngClass]="{'populated' : searchMember}">
                <label class="fl_label" for="searchMember">Search by First Name, Last Name, or NPI Number</label>
                <input class="fl_input" name="searchMember" type="textbox" placeholder="" [(ngModel)]="searchMember"
                    (keyup)="searchForMembers()">
            </div>
            <ul [hidden]="!showSearchContactList" class="nameList">
                <li *ngFor="let contacts of searchContactList" (click)="setshowContactForm(contacts.acepId, true)">
                    {{contacts.formalName}} {{contacts.npiNumber}} {{contacts.city}} {{contacts.state}}</li>
                <li (click)="setshowContactForm(0, true)">Can't find who I'm looking for</li>
            </ul>
        </div>
    </div>
    <div class="FlowupLabels" [hidden]="slideOutType != 'editMember'">
        <div class="sidebar-header">
            <h2 class="black">
                <span class="snHeadingArrow" (click)="slideOutBlur()"><i class="fa fa-chevron-left"></i></span> Edit
                Member
            </h2>
        </div>
    </div>

    <div class="FlowupLabels" [hidden]="slideOutType != 'addLeadership'">
        <div class="sidebar-header">
            <h2 class="black">
                <span class="snHeadingArrow" (click)="slideOutBlur()"><i class="fa fa-chevron-left"></i></span> Add
                Leadership
            </h2>
        </div>
    </div>


    <div class="FlowupLabels" [hidden]="showInvalidResidencyMsg || (!showContactForm && slideOutType !== 'editMember' && slideOutType !== 'addLeadership')">
        <div class="fl_wrap" [ngClass]="{'populated' : selectedContactDetails.prefix}">
            <label class="fl_label" for="prefix">Prefix</label>
            <select class="fl_input" name="prefix" [(ngModel)]="selectedContactDetails.prefix">
                <option value=""></option>
                <option *ngFor="let obj of ui_prefixes" [value]="obj.label">{{obj.label}}</option>
            </select>
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap {{(selectedContactDetails?.FirstName ? '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.FirstName}">
            <label class="fl_label" for="firstName">First Name</label>
            <input class="fl_input" name="firstName" type="textbox" placeholder=""
                [(ngModel)]="selectedContactDetails.FirstName">
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : selectedContactDetails.MiddleName}">
            <label class="fl_label" for="middleInitial">Middle Initial</label>
            <input class="fl_input" name="middleInitial" type="textbox" placeholder=""
                [(ngModel)]="selectedContactDetails.MiddleName">
        </div>
        <div class="fl_wrap {{(selectedContactDetails.LastName ? '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.LastName}">
            <label class="fl_label" for="lastName">Last Name</label>
            <input class="fl_input" name="lastName" type="textbox" placeholder=""
                [(ngModel)]="selectedContactDetails.LastName">
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : selectedContactDetails.jobTitle}">
            <label class="fl_label" for="jobTitle">Professional Designation (e.g. D.O., M.D., PA-C)</label>
            <input class="fl_input" name="jobTitle" type="textbox" placeholder=""
                [(ngModel)]="selectedContactDetails.jobTitle">
        </div>
        <div class="fl_wrap {{(selectedContactDetails?.NPINumber || groupPortalDataService.groupList.GroupInfo?.residencyDetail ||
            groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid == 'Yes' || slideOutType === 'addLeadership' ? '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.NPINumber}">
            <label class="fl_label" for="npiNumber">NPI Number</label>
            <input class="fl_input" name="npiNumber" (keyup)="searchForContactByNPI()" type="textbox" maxLength="10"
                placeholder="" [(ngModel)]="selectedContactDetails.NPINumber">
            <span class="validationhead">Required</span>
            <span class="customFormError" *ngIf="npiInvalid">Invalid NPI Number</span>
            <span class="customFormError" *ngIf="npiExist && slideOutType !== 'addLeadership'">NPI Number exists</span>
        </div>

        <ng-container *ngIf="selectedGroup?.accountCategory === 'Physician Group'">
            <app-residency-details #residencyDetailsComp [selectedContactDetails]="selectedContactDetails" 
             [formSubmitted]="formsubmitted" [ui_Residencies]="ui_residencies" [ui_Specialities]="ui_specialities">
            </app-residency-details>
        </ng-container>

        <div class="fl_wrap" [ngClass]="{'populated' : selectedContactDetails.AddressType}">
            <label class="fl_label" for="addressType">Member's Address Type</label>
            <select class="fl_input" name="addressType" (change)="changeContactAddress()"
                [(ngModel)]="selectedContactDetails.AddressType" required="required">
                <option value="1">Home</option>
                <!-- <option value="2">Hospital</option> -->
                <option value="3">Business</option>
            </select>
        </div>
        <div class="fl_wrap {{(selectedContactDetails?.Country || slideOutType === 'addLeadership' ? '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.Country}">
            <label class="fl_label" for="Country">Country</label>
            <select class="fl_input" name="Country" [(ngModel)]="selectedContactDetails.Country"
                (change)="onCountrySelect($event.target.value)" required="required">
                <option value=""></option>
                <option *ngFor="let obj of ui_countries" [value]="obj.acep_iso2code">{{obj.acep_name}}</option>
            </select>
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : selectedContactDetails.AddressAttention}"
            *ngIf="selectedContactDetails.AddressType != 1">
            <label class="fl_label" for="attention">Organization</label>
            <input class="fl_input" name="attention" type="textbox" placeholder=""
                [(ngModel)]="selectedContactDetails.AddressAttention">
        </div>
        <div class="fl_wrap {{(selectedContactDetails?.Street || slideOutType === 'addLeadership' ? '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.Street}">
            <label class="fl_label" for="street">Address 1</label>
            <input class="fl_input" name="street" type="textbox" placeholder=""
                [(ngModel)]="selectedContactDetails.Street">
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : selectedContactDetails.Apt}">
            <label class="fl_label" for="apt">Address 2</label>
            <input class="fl_input" name="apt" type="textbox" placeholder="" [(ngModel)]="selectedContactDetails.Apt">
        </div>

        <div class="fl_wrap {{(selectedContactDetails?.City || slideOutType === 'addLeadership' ? '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.City}">
            <label class="fl_label" for="city">City</label>
            <input class="fl_input" name="city" type="textbox" placeholder="" [(ngModel)]="selectedContactDetails.City">
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap {{(selectedContactDetails?.State || slideOutType === 'addLeadership'
                                    || (selectedContactDetails.Country != 'US' && selectedContactDetails.Country != 'CA') ?
                                    '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.State}"
            *ngIf="ui_stateprovinces && ui_stateprovinces?.length > 0">
            <label class="fl_label" for="StateProvince">State/Province</label>
            <select class="fl_input" name="StateProvince" [(ngModel)]="selectedContactDetails.State"
                (change)="onStateSelect($event.target.value)" required="required">
                <option value=""></option>
                <option *ngFor="let obj of ui_stateprovinces" [value]="obj.acep_isocode">{{obj.acep_name}}</option>
            </select>
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap {{(!selectedContactDetails?.Zip && slideOutType !== 'addLeadership'
                                    && selectedContactDetails.Country == 'US' || selectedContactDetails.Country == 'CA' ?
                                    (formsubmitted ? ' validation-error' : '') : '' )}}"
            [ngClass]="{'populated' : selectedContactDetails.Zip}">
            <label class="fl_label" for="zipCode">Zip/Postal Code</label>
            <input class="fl_input" name="zipCode" maxLength="10" type="textbox" placeholder=""
                [(ngModel)]="selectedContactDetails.Zip">
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap {{(selectedContactDetails?.EmailAddress ? '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.EmailAddress}">
            <label class="fl_label" for="email">Email</label>
            <input class="fl_input" name="email" type="textbox" (keyup)="email$.next($event.target.value)"
                (focusout)="email$.next($event.target.value)" placeholder=""
                [(ngModel)]="selectedContactDetails.EmailAddress">
            <!-- (keyup)="checkIfEmailExists()" -->
            <span class="validationhead">Required</span>
            <span class="customFormError" *ngIf="emailInvalid">Invalid Email</span>
            <span class="customFormError" *ngIf="!emailInvalid && emailExists && slideOutType !== 'addLeadership'">A
                record already exists with this email</span>
        </div>
        <div class="fl_wrap {{(selectedContactDetails?.Phone || slideOutType === 'addLeadership' ?  '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.Phone}">
            <label class="fl_label" for="phone">Phone</label>
            <input class="fl_input" name="phone" type="textbox" placeholder=""
                [(ngModel)]="selectedContactDetails.Phone">
            <span class="validationhead">Required</span>
        </div>



        <div class="fl_wrap {{(selectedContactDetails?.Chapter || slideOutType === 'addLeadership' ?
                                    '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.Chapter}"
            *ngIf="eligibleChapters && eligibleChapters?.length > 0">
            <label class="fl_label" for="Chapter">Chapter</label>
            <select class="fl_input" name="Chapter" [(ngModel)]="selectedContactDetails.Chapter"
                (change)="onChapterSelect($event.target.value)" required="required">
                <option value=""></option>
                <option *ngFor="let obj of eligibleChapters" [value]="obj.acep_code">{{obj.name}}</option>
            </select>
            <span class="validationhead">Required</span>
        </div>


        <div class="fl_wrap {{(chapterChangeCheckBoxSelected ? '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : showChapterConfirmCheckbox}"
            *ngIf="showChapterConfirmCheckbox && eligibleChapters?.length > 0">


            <div class="checkbox c-checkbox needsclick" [hidden]="slideOutType === 'addLeadership' ">
                <label class="needsclick fl_label">By changing this chapter I agree that I’ve discussed the chapter
                    assignment with the member</label>

                <input #confirmChangeChapter [(ngModel)]="chapterChangeCheckBoxSelected" class="fl_input needsclick"
                    style="height: 25px;" name="confirmChangeChapter" type="checkbox" placeholder=""
                    required="required">
                <span class="fa fa-check"></span>
            </div>

            <span class="validationhead">Required</span>

        </div>






        <div [hidden]="slideOutType === 'addLeadership'"
            class="fl_wrap {{(selectedContactDetails?.startDate || slideOutType === 'addLeadership' ? '' : (formsubmitted ? ' validation-error' : ''))}}"
            [ngClass]="{'populated' : selectedContactDetails.startDate}">
            <label class="fl_label" for="startDate">Group Membership Start Date</label>
            <input class="fl_input" id="startDate" matInput [readonly]="selectedGroup?.accountCategory === 'Residency'"
                (onchange)="checkIfEndDateValid()" [(ngModel)]="selectedContactDetails.startDate"
                [matDatepicker]="startDate">
            <mat-datepicker-toggle matSuffix [for]="startDate" style="float: right;"></mat-datepicker-toggle>
            <mat-datepicker #startDate [disabled]="false"
                [startView]="selectedGroup?.accountCategory === 'Residency' ? 'multi-year' : 'month'"
                (yearSelected)="selectedGroup?.accountCategory === 'Residency' ? handleYearSelected($event, startDate, 'start') : null"
                (opened)="onDatePickerOpened($event)"></mat-datepicker>
            <!-- <label class="fl_label" for="startDate">Group Membership Start Date</label>
                        <input class="fl_input" name="startDate" type="textbox"
                            placeholder="" [(ngModel)]="selectedContactDetails.startDate"> -->
            <span class="validationhead">Required</span>
        </div>
        <div [hidden]="slideOutType === 'addLeadership'" class="fl_wrap 
        {{(
            (!selectedContactDetails?.endDate && (groupPortalDataService.groupList.GroupInfo?.physgrpDetail || !formsubmitted)) ||
            (selectedContactDetails?.endDate && selectedContactDetails?.startDate < selectedContactDetails?.endDate && compareToCycleStartDate()) ||
            slideOutType === 'addLeadership' ? '' : compareEndDate() ?' validation-error' :''
        )}}"
            [ngClass]="{'populated' : selectedContactDetails.endDate}">
            <label class="fl_label" for="endDate">Group Membership End Date</label>
            <input class="fl_input" id="endDate" matInput [readonly]="selectedGroup?.accountCategory === 'Residency'"
                (onchange)="checkIfEndDateValid()" [(ngModel)]="selectedContactDetails.endDate"
                [matDatepicker]="endDate">
            <mat-datepicker-toggle matSuffix [for]="endDate" style="float: right;"></mat-datepicker-toggle>
            <mat-datepicker #endDate [disabled]="false"
                [startView]="selectedGroup?.accountCategory === 'Residency' ? 'multi-year' : 'month'"
                (yearSelected)="selectedGroup?.accountCategory === 'Residency' ? handleYearSelected($event, endDate, 'end') : null"
                (opened)="onDatePickerOpened($event)"></mat-datepicker>
            <span class="validationhead">{{selectedContactDetails?.endDate ? 
                (compareToCycleStartDate() ? 
                  (compareEndDate() ? 'End Date must be after Start Date' : '') :
                  'End Date must be after the billing option Start Date of ') : 'Required'}}
                {{!selectedContactDetails?.endDate || compareToCycleStartDate() ? '' :
                groupPortalDataService.groupList.GroupInfo.residencyDetail.cycleStartDate | date: 'shortDate'}}</span>
            <!-- <input class="fl_input" name="endDate" type="textbox"
                            placeholder="" [(ngModel)]="selectedContactDetails.endDate"> -->

        </div>
        <div class="fl_wrap">


            <div class="checkbox c-checkbox needsclick"
                [hidden]="slideOutType === 'addLeadership' || !groupPortalDataService.inGroupBilling">
                <label class="needsclick fl_label">Group Billing</label>
                <!-- left in by mohan? -->
                <!-- {{emailValid}} -->
                <input class="fl_input needsclick" style="height: 25px;" name="groupBilling" type="checkbox"
                    placeholder="" [(ngModel)]="selectedContactDetails.groupBilling">
                <span class="fa fa-check"></span>
            </div>
        </div>

        <div [hidden]="slideOutType != 'addLeadership'">
            <button class="btn greyBtn left" (click)="slideOutBlur()">Cancel</button>
            <button class="btn btn-primary right" (click)="addMemberToGroup(newMember, true)">Add to Leadership</button>
        </div>

        <div [hidden]="slideOutType != 'addMember'">
            <button class="btn greyBtn left" (click)="setshowContactForm(0,false)">Return to Search</button>
            <button class="btn btn-primary right" (click)="addMemberToGroup(newMember)">Add Member</button>
        </div>

        <div [hidden]="slideOutType != 'editMember'">
            <button class="btn greyBtn left" (click)="cancelEdit()">Cancel</button>
            <button class="btn btn-primary right" [disabled]="!pageValid" (click)="editContact()">Save</button>
        </div>
    </div>
    <div [hidden]="!selectedContactDetails?.showSuccessMsg">
        <div class="row" style="padding-bottom: 20px;">
            You have successfully added &nbsp; <strong> {{ selectedContactDetails?.FirstName }}
                {{selectedContactDetails?.MiddleName ?
                selectedContactDetails?.MiddleName + ' ' : ''}}{{selectedContactDetails?.LastName ?
                selectedContactDetails?.LastName : ''}} </strong> &nbsp; to your group.
        </div>
        <!-- <div [hidden]="groupPortalDataService.groupList.GroupInfo?.residencyDetail">
            <div class="row" style="padding-bottom: 20px;">
                An email was sent to the new group member if their status is 'Application Pending' requiring the new group member to provide the following information to fulfill membership requirements:
            </div>
            <div class="row" [hidden]="groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid == 'Yes'">
                - Medical School and Residency
            </div>
            <div class="row" [hidden]="groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid == 'No'">
                - Graduate and Residency Program
            </div>
            <div class="row">
                - Board Certification
            </div>
            <div class="row" [hidden]="groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid == 'Yes'">
                - Primary Chapter Designation
            </div>
            <div class="row">
                - Medical License
            </div>
        </div> -->

        <div class="row" *ngIf="isFormalMedicalStudent">
            An email was sent to the new group member requiring them to provide the following information to fulfill
            membership requirements:
            <br><br>-EM Residency program name and graduation date.<br><br>
        </div>

        <!-- <div class="row" *ngIf="isNeverBeenAnACEPMember">
            An email was sent to the new group member requiring them to provide the following information to fulfill
            membership requirements:
            <br><br>-Medical School name & graduation date.<br>-EM Residency program name and graduation date.<br><br>
        </div> -->

        <div class="row" *ngIf="isFormerSEMPAMember">
            An email was sent to the new group member requiring them to provide the following information to fulfill
            membership requirements:
            <br><br>-PA program name and graduation date<br>-If applicable, PA residency program name and graduation
            date<br><br>
        </div>

        <div class="row" *ngIf="isNeverBeenASEMPAMember">
            An email was sent to the new group member requiring them to provide the following information to fulfill
            membership requirements:
            <br><br>-PA program name and graduation date.<br>-If applicable, PA postgrad program name and graduation
            date.<br><br>
        </div>



        <button class="btn greyBtn left" (click)="returnToSearch()">Return to Search</button>
    </div>

    <div [hidden]="!showInvalidResidencyMsg">
        <div class="row" style="padding-bottom: 20px; display: block; padding-left: 20px;">
            We need more information about this person. If you would like to add this individual to <br>
            your group, please contact
            <span style="display: inline-block;">
                <a href="mailto:acepgroupbilling@acep.org"
                    style="color: #1866FF; display: inline-block; padding: 8px 8px 8px 0px;">acepgroupbilling@acep.org</a>for
                further assistance.
            </span>
        </div>

        <button class="btn greyBtn left" (click)="returnToSearch()">Return to Search</button>
    </div>
</div>

<!-- Sidebar  -->

<div class="remodal" data-remodal-id="editMemberContact">
    <div>This contact is already a member of the selected group. Would you like to continue with editing the contacts
        information?</div>
    <a data-remodal-action="cancel" class="remodal-cancel" (click)="closeModal()">NO</a>
    <a data-remodal-action="confirm" class="remodal-confirm" (click)="openContactEdit()">YES</a>
</div>
<!--
  <pre>
      {{ui_countries | json}}
  </pre> -->